type BrandLocale = "en" | "ar";

export function renderShdeedBrand(locale: BrandLocale): string {
  return `<img class="shdeed-brand-lockup" src="/brand/shdeed-horizontal-color-light.svg" width="164" height="56" alt="${locale === "ar" ? "شديد" : "Shdeed"}" dir="ltr">`;
}

export function renderCloudPixelEndorsement(locale: BrandLocale): string {
  return `<img class="cloudpixel-endorsement" src="/brand/powered-by-cloudpixel-light.svg" width="170" height="25" alt="${locale === "ar" ? "بدعم من CloudPixel" : "Powered by CloudPixel"}" dir="ltr">`;
}
